import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFmharrup from '@/components/UI/svg/Icons/EFmharrup';

export default function MhIh5({}: any) {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('waveportableairconditioner');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        new ScrollMagic.Scene({
            triggerElement: '.mhIh5',
        })
            .setClassToggle('.list', 'isEnter')
            .addTo(controller);
    }, []);

    return (
        <div className={`${css.mhIh5} mhIh5`}>
            <div className="mh-inter">
                <div className="topHalf">
                    <div className="topBox">
                        <div className="ms1">{t('mh200.mhH_ms8')}</div>
                        <div className="ms2">
                            {/*<Image src='/product/mh200/pc/blueUp.svg' layout='fill' className='fullImgs' />*/}
                            <EFmharrup />
                        </div>
                        <div className="percent">{t('mh200.mhH_ms9')}</div>
                    </div>
                    <div className="ms3">{t('mh200.mhH_ms10')}</div>
                </div>
                <div className="bottomHalf">
                    <li className="list list1">
                        <div className="prog"></div>
                        <span className="hr">{t('mh200.mhH_ms12')}</span>
                        <div className="text">{t('mh200.mhH_ms1')}</div>
                    </li>
                    <li className="list list2">
                        <div className="prog"></div>
                        <span className="hr">{t('mh200.mhH_ms14')}</span>
                        <div className="text">{t('mh200.mhH_ms3')}</div>
                    </li>
                    <li className="list list3">
                        <div className="prog"></div>
                        <div className="text">{t('mh200.mhH_ms16_h5')}</div>
                    </li>
                </div>
            </div>
        </div>
    );
}
